module.exports = __webpack_public_path__ + "img/5aa5386.webp";